import { GuestProfile } from "@closerplatform/spinner-openapi";
import { flow, Instance, SnapshotIn, types } from "mobx-state-tree";
import { Guest } from "../base/Guest";
import { servicesGetters } from "../utils";

export const GuestStore = types
  .model("GuestStore", {
    guests: types.map(Guest)
  })
  .views(servicesGetters)
  .actions((self) => ({
    loadByRoomId: flow(function* loadByRoomId(roomId: string) {
      const guest: GuestProfile = yield self.spinnerService.getGuestProfileByRoom(roomId);
      self.guests.put(guest);
    }),
    add(guest: SnapshotIn<typeof Guest>) {
      self.guests.put(guest);
    }
  }));

export interface IGuestStore extends Instance<typeof GuestStore> {}
